import type { ImageCreationPanelFragment } from "../../client/generated";
import { useTranslation } from "react-i18next";
import { AttributePanel } from "../AttributePanel";
import { useCreateImageFromPanelMutation } from "../../client/generated";

type Props = {
  fragment: ImageCreationPanelFragment;
  onDelete: () => Promise<void>;
};

export function ImageCreationPanel({ fragment, onDelete }: Props) {
  const { t } = useTranslation();
  const [createAttribute] = useCreateImageFromPanelMutation();

  const onSave = async () => {
    await createAttribute({
      variables: {
        regionId: fragment.id,
      },
    });
    await onDelete();
  };

  return (
    <AttributePanel
      title={t("ImageCreationPanel.title")}
      unsaved
      onSubmit={onSave}
      onDelete={onDelete}
    />
  );
}
